import React from "react";
import { ObraDetailsPage } from "./obraDetails.page";
import { ObraDetailsProvider } from "./context/obra-details-context";

export function ObraDetailsFactory() {
    return (
        <ObraDetailsProvider>
            <ObraDetailsPage />
        </ObraDetailsProvider>
    );
}
